import ModalCustom from "components/ModalCustom"
import { ReactComponent as IconGoogleAuthen } from "assets/images/icons/google-authen.svg"
import Button from "components/Button/Button"
import InputDefault from "components/Input/InputDefault"
import FormInputCard from "pages/auth/molecules/FormInputCard"
import { useString } from "helpers/hooks"
import { useChangeLabelStatusInputPasswordAndConfirm } from "pages/auth/auth.hook"
import { STATUS_INPUT } from "components/Input/types"
import { encryptionController } from "controllers/EncryptionController"
import { postUpdateSecurityCodeAndPhoneNumberMiddleware } from "pages/auth/services/api"
import { toast } from "react-toastify"
import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import { NAME_LOCALSTORAGE } from "constants/localStorage"

interface Props {
  isGenerateNewRecoveryCode?: boolean
  handleUpdateSecurityCodeAndPhoneNumber: (currentPassword: string) => void
  onCloseModal: () => void
}
export const WarningSecurityCodeAndPhoneNumberModal = (props: Props) => {
  const {
    handleUpdateSecurityCodeAndPhoneNumber,
    isGenerateNewRecoveryCode,
    onCloseModal,
  } = props
  const password = useString()
  const { statusInputPassword, getStatusInputPassword } =
    useChangeLabelStatusInputPasswordAndConfirm()
  const onKeyPress = (event: React.KeyboardEvent<HTMLDivElement>): void => {
    if (event.key === "Enter") {
      onSubmitGetStarted()
    }
  }

  const handleChangeInput = (event) => {
    password.setValue(event.target.value)
    getStatusInputPassword(event.target.value)
  }

  const renderHeader = () => {
    return (
      <div className="flex">
        <IconGoogleAuthen />
        <p className="ml-[8px] text-[16px] text-[#222222] font-semibold">
          Secure Your Account
        </p>
      </div>
    )
  }

  const onSubmitGetStarted = async () => {
    if (statusInputPassword.status !== STATUS_INPUT.VALID) {
      return
    }
    const { generatePasswordHashed } = encryptionController()
    const request = {
      password: await generatePasswordHashed(password.value),
    }
    postUpdateSecurityCodeAndPhoneNumberMiddleware(request)
      .then(async () => {
        handleUpdateSecurityCodeAndPhoneNumber(password.value)
      })
      .catch((error) => {
        const message = error.response?.data?.message ?? "Something went wrong!"
        toast(<LabelNotificationPage messenger={message} type="error" />)
      })
  }

  const onRemindMeLater = () => {
    localStorage.setItem(NAME_LOCALSTORAGE.REMIND_ME_LATER, "true")
    onCloseModal()
  }

  const renderBody = () => {
    return (
      <div className="flex flex-col">
        <p className="text-[14px] text-[#222222] leading-[24px]">
          We've enhanced our security process.
        </p>
        {!isGenerateNewRecoveryCode ? (
          <p className="text-[14px] text-[#222222] leading-[24px]">
            Please regenerate your backup key to continue.
          </p>
        ) : null}

        <p className="text-[14px] text-[#222222] leading-[24px] mb-[12px]">
          You’ll be asked to provide a few additional details.
        </p>
        <FormInputCard required title="Current Password">
          <InputDefault
            type="password"
            isPassword
            value={password.value}
            onChange={handleChangeInput}
            onKeyPress={onKeyPress}
            status={statusInputPassword.status}
            labelStatus={statusInputPassword.label}
          />
        </FormInputCard>
        <div className="flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-between mt-[16px]">
          {!isGenerateNewRecoveryCode ? (
            <Button
              widthBtn={"100%"}
              title="Remind me later"
              colorBtn="white"
              onClick={onRemindMeLater}
            />
          ) : null}

          <Button
            widthBtn={"100%"}
            title="Get Started"
            onClick={onSubmitGetStarted}
            disabled={statusInputPassword.status !== STATUS_INPUT.VALID}
            isDisabledBtn
          />
        </div>
      </div>
    )
  }
  return (
    <ModalCustom
      widthModal={400}
      styleHeaderModal={{
        height: "auto",
        paddingTop: 12,
        alignItems: "start",
      }}
      handleChangeButton={
        isGenerateNewRecoveryCode ? () => onCloseModal : undefined
      }
      label={
        isGenerateNewRecoveryCode ? "Generate new recovery code" : undefined
      }
      renderHeader={isGenerateNewRecoveryCode ? undefined : renderHeader()}
      bodyChildren={renderBody()}
    />
  )
}
